import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsSoftwareProformaEditFormsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-proforma-edit-forms',
	path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
	exact: true,
};
